import angular from 'angular';
import MenuItemDirective from './menu-item.directive';

let MenuItemModule = angular.module('home.menuItem', [])
  .directive('menuItem', MenuItemDirective);

export default MenuItemModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/home/menu/menu-item/menu-item.js
 **/